var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34.62 34.62"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.62 6.58L28.04 0 17.31 10.73 6.58 0 0 6.58l10.73 10.73L0 28.04l6.58 6.58 10.73-10.73 10.73 10.73 6.58-6.58-10.73-10.73L34.62 6.58z",
    "data-name": "Layer 2",
    fill: "#cedfd7"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzNC42MiAzNC42MiI+PHBhdGggc3R5bGU9ImZpbGw6I2NlZGZkNyIgZD0iTTM0LjYyIDYuNTggMjguMDQgMCAxNy4zMSAxMC43MyA2LjU4IDAgMCA2LjU4bDEwLjczIDEwLjczTDAgMjguMDRsNi41OCA2LjU4IDEwLjczLTEwLjczIDEwLjczIDEwLjczIDYuNTgtNi41OC0xMC43My0xMC43M0wzNC42MiA2LjU4eiIgZGF0YS1uYW1lPSJMYXllciAyIi8+PC9zdmc+";
export { SvgCross as ReactComponent };